import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Main } from "@/app/layout/Main";
import { useCreateInstructor } from "../api/queries";
import {
  InstructorForm,
  instructorFormValuesToCreateDTO,
} from "../ui/instructors/InstructorForm";

export function InstructorCreatePage() {
  const nav = useNavigate({ from: "/app/master/instructors/create" });
  const createInstructor = useCreateInstructor();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຄູສອນ", to: "/app/master/instructors" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງຄູສອນ
            </h2>
            <p className="text-muted-foreground">ສ້າງຄູສອນໃໝ່ໃນລະບົບ.</p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/master/instructors" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <InstructorForm
            onSubmit={async (vals) => {
              try {
                await createInstructor.mutateAsync(
                  instructorFormValuesToCreateDTO(vals),
                );

                nav({ to: "/app/master/instructors" });
              } catch (error) {
                // Error handling is done by the mutation
              }
            }}
            submitting={createInstructor.isPending}
          />
        </div>
      </Main>
    </>
  );
}
